/*
 * Copyright (c) Nexign, JSC, 2019-2022.
 */
/**
 * Page dashboard translation constants
 *
 * @author Nikolay Sviridov
 * @version 1.34.0
 * @since 1.34.0
 */

import { ReactElement } from 'react';

import { Typography } from '@nexign/scc-ui-kit';

import { ImgStyled } from '@/main/components/common/Block/Img';

import { EFastActionsButtonTypes } from './constants/constants';
import { FastActionButtonStyled } from './styled/FastActionsPlateStyled';

export interface IFastActionButtonProps {
    buttonType: EFastActionsButtonTypes;
    buttonText: ReactElement | string;
    dataName?: string;
    disabled?: boolean;
    buttonIcon?: string;
    onClick?: () => void;
}

export const FastActionButton = ({ 
    buttonText, 
    buttonType, 
    buttonIcon, 
    dataName, 
    disabled, 
    onClick,
}: IFastActionButtonProps) => {
    const buttonTextForRender = typeof buttonText === 'string' 
        ? <Typography variant="body2">{buttonText}</Typography> 
        : buttonText;
    return (
        <FastActionButtonStyled
            className="fast-actions-button"
            color='white'
            data-name={dataName}
            disabled={disabled}
            key={buttonType}
            size="small"
            variant="contained"
            onClick={onClick}
        >
            {buttonIcon && <ImgStyled className="small" src={buttonIcon}/>}
            {buttonTextForRender}
        </FastActionButtonStyled>
    )
};
